import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { checkValue } from 'utils';
import { renderWithTooltip } from 'utils/table';

export const columns = [
  {
    title: 'Заголовок',
    dataIndex: 'title',
    key: 'title',
    render: (value) => renderWithTooltip(value),
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
      return (
        <TableSearchPanel>
          <Input
            autoFocus
            placeholder="Поиск по заголовоку"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
          />
        </TableSearchPanel>
      );
    },
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) => {
      return record?.title.toLowerCase().includes(value.toLowerCase());
    },
  },
  {
    title: 'Заголовок (каз)',
    dataIndex: 'title_kz',
    key: 'title_kz',
    render: (value) => renderWithTooltip(value),
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
      return (
        <TableSearchPanel>
          <Input
            autoFocus
            placeholder="Поиск по заголовоку (каз)"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
          />
        </TableSearchPanel>
      );
    },
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) => {
      return record?.title_kz.toLowerCase().includes(value.toLowerCase());
    },
  },
  {
    title: 'Медиа',
    dataIndex: 'thumbnail',
    key: 'thumbnail',
    render: (value) => {
      if (value) {
        return (
          <a
            href={`${process.env.REACT_APP_HOSTNAME}/api/media/${value}/`}
            target="blank"
            onClick={(e) => e.stopPropagation()}
          >
            {value}
          </a>
        );
      }

      return checkValue(value);
    },
  },
  {
    title: 'Медиа (каз)',
    dataIndex: 'thumbnail_kz',
    key: 'thumbnail_kz',
    render: (value) => {
      if (value) {
        return (
          <a
            href={`${process.env.REACT_APP_HOSTNAME}/api/media/${value}/`}
            target="blank"
            onClick={(e) => e.stopPropagation()}
          >
            {value}
          </a>
        );
      }

      return checkValue(value);
    },
  },
  {
    title: 'Количество истории',
    dataIndex: 'count',
    key: 'count',
  },
  {
    title: ' Порядок',
    dataIndex: 'position',
    key: 'position',
  },
];
